import { useEffect, useState } from "react";
import { getFieldIcon } from "../../../../utils/getFieldIcon";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import { useTemplateContext } from "../../../../context/TemplateContext";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

const advanceFields = [
  {
    id: "empty",
    type: "empty",
    name: "Fields"
  },
  {
    name: "Timeline",
    type: "timeline",
    id: "timeline"
  },
  {
    name: "Form",
    type: "form",
    id: "form"
  },
  {
    name: "Mail thread",
    type: "mail_thread",
    id: "mail_thread"
  }
];

const container = [
  {
    name: "Section",
    type: "section",
    id: "section"
  }
];

const positionedContainer = [
  {
    name: "Column",
    type: "column",
    id: "column"
  },
  {
    name: "Block",
    type: "block",
    id: "block"
  }
];

const basicElements = [
  {
    name: "Spacer",
    type: "spacer",
    id: "spacer"
  },
  {
    name: "Label",
    type: "label",
    id: "label"
  },
  {
    name: "Image",
    type: "image",
    id: "image"
  },
  {
    name: "Tabview",
    type: "tabview",
    id: "tabview"
  },
  {
    name: "Tableview",
    type: "tableview",
    id: "tableview"
  },
  {
    name: "File Viewer",
    type: "file_viewer",
    id: "file_viewer"
  },
  {
    name: "File Preview",
    type: "file_preview",
    id: "file_preview"
  },
  {
    name: "Separator",
    type: "separator",
    id: "separator"
  },
  {
    name: "Icon",
    type: "icon",
    id: "icon"
  },
  {
    name: "JsonToTable",
    type: "json_to_table",
    id: "json_to_table"
  }
];

const actionElements = [
  {
    name: "Button",
    type: "button",
    id: "button"
  },
  {
    name: "Dropdown",
    type: "dropdown",
    id: "dropdown"
  },
  {
    name: "Button Group",
    type: "button-group",
    id: "button-group"
  }
];

const customElements = [
  {
    name: "HTML",
    type: "html",
    id: "html"
  },
  {
    name: "Dynamic-html",
    type: "dynamic-html",
    id: "dynamic-html"
  }
];

const widget = [
  {
    id: "progress-tracker",
    name: "Progress Tracker",
    type: "progress-tracker"
  }
];

const DetailsviewElementsBar = ({
  handleDragStart,
  activityCardsData = [],
  activityBlocksData = [],
  isPositionedScreen = false
}) => {
  const [blockFields, setBlockFields] = useState({
    activityCardFields: [],
    activityRecordviewFields: [],
    activityChartFields: [],
    progressBarFields: []
  });

  const { getReactComponents, reactComponent } = useTemplateContext();

  useEffect(() => {
    getReactComponents();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDynamicFields = () => {
    const activityCardFields = [];
    const activityRecordviewFields = [];
    const activityChartFields = [];
    const progressBarFields = [];

    if (activityCardsData) {
      for (const act_card of activityCardsData) {
        if (act_card.name) {
          activityCardFields.push({
            id: act_card.id,
            name: act_card.name,
            type: "activitycard"
          });
        }
      }
    }

    if (activityBlocksData) {
      for (const block of activityBlocksData) {
        if (block.name) {
          let blockType = block.parentData.split("/")[1];
          let name = block.name;
          let parentData = blockType === "progress-bar" ? `${blockType}` : `activity-${blockType}`;

          const fieldData = {
            id: block.id,
            name: name,
            type: parentData
          };

          switch (blockType) {
            case "recordsview":
              activityRecordviewFields.push(fieldData);
              break;
            case "chart":
              activityChartFields.push(fieldData);
              break;
            case "progress-bar":
              progressBarFields.push(fieldData);
              break;
            default:
              break;
          }
        }
      }
    }
    setBlockFields({
      activityCardFields,
      activityRecordviewFields,
      activityChartFields,
      progressBarFields
    });
  };

  useEffect(() => {
    getDynamicFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createFieldForReactComponent = (components) => {
    return components.map((eachComponents) => {
      return { id: eachComponents.id, type: "custom-component", name: eachComponents.name };
    });
  };

  const fieldGroup = (heading, fieldList) => {
    if (fieldList.length === 0) return;
    return (
      <>
        <label className="builder_label">{heading}</label>
        <div className="draggable_formField_rightPanel">
          {fieldList.map((field, index) => (
            <DropField key={field.id + "-" + index} field={field} handleDragStart={handleDragStart} />
          ))}
        </div>
      </>
    );
  };
  const allTabs = [
    {
      label: "Static",
      content: (
        <div className="draggable_formField_rightPanel_outer">
          {fieldGroup("Container", [...container, ...(isPositionedScreen ? positionedContainer : [])])}
          {fieldGroup(
            "Basic Elements",
            isPositionedScreen ? basicElements.filter((el) => el.type !== "spacer") : basicElements
          )}
          {fieldGroup("Action Elements", actionElements)}
          {fieldGroup("Custom Elements", customElements)}
          {fieldGroup("React Components", createFieldForReactComponent(reactComponent))}
        </div>
      )
    },
    {
      label: "Fields",
      content: (
        <div className="draggable_formField_rightPanel_outer">
          {fieldGroup("Fields", advanceFields)}
          {fieldGroup("Activity Card", blockFields.activityCardFields)}
          {fieldGroup("Activity Recordsview", blockFields.activityRecordviewFields)}
          {fieldGroup("Activity Charts", blockFields.activityChartFields)}
          {fieldGroup("Progress Bar", blockFields.progressBarFields)}
        </div>
      )
    },
    {
      label: "Widgets",
      content: <div className="draggable_formField_rightPanel_outer">{fieldGroup("Widget", widget)}</div>
    }
  ];
  return (
    <div className="rightsidebar">
      <BuilderTabs tabs={allTabs} containerClass="form_field" />
    </div>
  );
};

const DropField = ({ field, handleDragStart }) => {
  return (
    <div
      key={`${field.type}-index`}
      onDragStart={(e) => handleDragStart && handleDragStart(e, field.name, field.id, field.type, field?.data)} // data is only for react component
      draggable={handleDragStart ? true : false}
      className="draggable_input_field"
    >
      <MaterialIcon name={getFieldIcon(field.type)} />
      <span className="field_name">{field.name}</span>
    </div>
  );
};

export default DetailsviewElementsBar;
